import React from 'react';
// import ReactGA from 'react-ga';
import Sponsors from '../Sponsors/Sponsors';
import About from '../About/About';
// import CountDown from '../../components/Countdown/CountDown';
import SpeakersContainer from '../Speakers/Speakers';
import './Home.scss';
import PrivacySection from '../PrivacySection/PrivacySection';

const Home = () => {
  // const onRegisterClick = () => {
  //   if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
  //     ReactGA.event({
  //       category: 'Button',
  //       action: 'Clicked Register Now button'
  //     });
  //   }
  // };

  return (
    <div id="home-section">
      <div className="container">
        <div className="home">
          <div />
          <div className="home-middle">
            <div className="home-middle-first-row">
              <div className="middle-year-left">2020</div>
              <div className="logo"> </div>
              <div className="middle-year-right">2020</div>
            </div>
            <div className="home-middle-second-row">
              <div className="info-icons">
                <i className="fas fa-calendar-alt icon" />
              </div>
              <div className="info-text">
                <div>OCTOBER 14 - 16, 2020</div>
              </div>
            </div>
            {/* <div className="home-middle-third-row">
              <CountDown
                afterDateMessage=""
                givenDate={new Date('Oct 14 2020 15:30:00')}
                title=""
              />
            </div> */}
            {/* <div className="home-middle-third-row">
              <button
                className="button is-large"
                id="cfs-button"
                onClick={() => history.push('/ff')}
                type="button">
                Feedback Form
              </button>
            </div> */}
          </div>
          <div className="home-bottom">
            <div className="home-bottom-left">
              <span>ACCENTURE CONFERENCE ON</span>
              <span className="bold-text">EMERGING TECHNOLOGIES</span>
              <span className="bold-text">AND OPEN SOURCE</span>
            </div>
            <div className="home-bottom-right">
              <div className="info-icons">
                <i className="fas fa-calendar-alt icon" />
              </div>
              <div className="info-text">
                <span>OCTOBER 14 - 16, 2020</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <About />
      <SpeakersContainer />
      <Sponsors />
      <PrivacySection />
    </div>
  );
};

export default Home;
